import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { DisplayValue, LayerValue, Pulverization } from '@/types/weed-diagnosis'

import { HerbicideTreatment } from './get-herbicide-treatments'

export interface DateRange {
  start_date: string
  end_date: string
}

interface PulvarizationLayer {
  layers: string[]
  buffer: number
  display?: DisplayValue
  herbicide_treatment?: HerbicideTreatment | null
}
export interface CreatePulverizationPayload {
  pulverization_layers: PulvarizationLayer[]
  pulverization_date: DateRange
  intersect: boolean
}

export interface PulverizationFromDemandResponse {
  id: string
  layers: Pulverization[]
  total_pulverization_area: LayerValue
  total_area: LayerValue
  pulverization_date: DateRange
}

export async function createPulverization(
  culture: string,
  demandId: string,
  payload: CreatePulverizationPayload,
) {
  const { data } = await companiesApi.post<PulverizationFromDemandResponse>(
    apiRoutes.createPulverization(culture, demandId),
    payload,
  )

  return data
}
